import { zSchema } from "../schema-validation";
import { EDepositRuleType } from "./DepositRuleType";

export const depositRuleResponseSchema = zSchema.object({
  priority: zSchema.number().int().min(1),
  type: zSchema.nativeEnum(EDepositRuleType),
  amount: zSchema.number().optional(),
  percentage: zSchema.number().min(0).max(100).optional(),
  bankAccountID: zSchema.string(),
  bankAccountDescription: zSchema.string(),
});
